import { cn } from '../../../../lib/styles';
import type { SectionTreeNodeType } from '../../types/section-tree';
import { ContextCard } from '../context-card';

const SectionNodeType: SectionTreeNodeType = ({ type, selected, ...props }) =>
  !('customer_group' in props) ? null : (
    <div className={cn('min-w-60', selected && 'rounded-xl shadow shadow-spark-purple')}>
      <ContextCard {...props}>{null}</ContextCard>
    </div>
  );
export default SectionNodeType;
